import styled from "styled-components";

export const Popup = styled.div`
  position: fixed;
  bottom: 28px;
  right: 28px;
  z-index: 9999;
  background: rgba(20, 20, 30, 0.96);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 22px 26px;
  min-width: 270px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CallerText = styled.p`
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 10px;
`;

export const AnswerBtn = styled.button`
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: none;
  background: #4caf50;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
`;

export const RejectBtn = styled.button`
  flex: 1;
  padding: 10px;
  border-radius: 8px;
  border: none;
  background: #ff4d4d;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
`;
